import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets scroll when the route changes (path or query). Scrolls window and any
 * <main> elements (e.g. AppLayout’s overflow-y-auto main) so new pages/lessons
 * start at the top.
 */
const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    if (document.documentElement) document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    document.querySelectorAll('main').forEach((el) => {
      el.scrollTop = 0;
    });
  }, [pathname, search]);

  return null;
};

export default ScrollToTop;
